import { render, staticRenderFns } from "./RevisionModulePage.vue?vue&type=template&id=420ba5ce&"
import script from "./RevisionModulePage.vue?vue&type=script&lang=ts&"
export * from "./RevisionModulePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports